import { Injectable } from '@angular/core';
import { RequestsServices } from './requests.service';

@Injectable()
export class AddressService {

  constructor(public request: RequestsServices) {

  }

  public addressToGeoPoint(addressAsString): any {
    return this.request.post('establishment_addresses', {address: addressAsString}, '', `/to-geopoint`);
  }

  public saveAddress(address): any {
    return this.request.post('establishment_addresses', address);
  }

  public updateAddress(address, id): any {
    return this.request.patch('establishment_addresses', address, '', `/${id}`);
  }
}
